import React, { useEffect } from "react";
import Title from "../components/Layout/Title/index";
import CartTable from "../components/Layout/CartTable/index";
import { useDispatch, useSelector } from "react-redux";
import { FetchCart } from "../Actions/cartAction";


export default function Cart() {
    const dispatch = useDispatch();
    const { cartItems } = useSelector((state) => state.cart);

    useEffect(() => {
        dispatch(FetchCart());
    }, []);
    
    const onClick = () =>{
        console.log("Casou")
    }

    return (
        <>
            <Title>Your Cart</Title>
            <CartTable
                onClick={onClick}
                products={cartItems}
                total={cartItems.reduce((a, c) => a + c.price * c.qty, 0)}
            ></CartTable>
        </>
    );
}
